module.exports = __webpack_public_path__ + "static/media/alarm-no.a15492bf.svg";